import axios from 'axios';
import Cookie from 'js-cookie';

import { Util } from '../common/util/util';
import { API_URL } from '../config/api.config';
import { removeTokensStorage } from '../service/auth/auth.helps';
import { AuthService } from '../service/auth/auth.service';

import { getContentType, getContentTypeToken } from './api.helpers';

export const axiosClassic = axios.create({
  baseURL: API_URL,
  headers: getContentTypeToken(),
});

export const instance = axios.create({
  baseURL: API_URL,
  headers: getContentType(),
});

/*instance.interceptors.request.use((config) => {
  console.log(config);
  const sessionToken = Cookie.get('st');
  if (config.headers && sessionToken) {
    config.headers['session-token'] = sessionToken;
    config.headers['Content-Type'] = 'application/json';
    config.headers.token = Util.getTokenSecurity();
  }
  /!*  if (config.headers && accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }*!/
  return config;
});

instance.interceptors.response.use(
  (config) => config,
  async (error) => {
    console.log(error);
  }
);*/

export default instance;
